import { IconRadar, IconRewrite, IconBoard } from "@/components/landing/icons";

/**
 * Discover → Prepare → Apply.
 *
 * Three steps rather than four, because these are the three things a job
 * search actually consists of; the finer-grained pipeline lives further down
 * the page where someone already interested wants the detail.
 */
const STEPS = [
  {
    icon: IconRadar,
    title: "Discover",
    body: "Save a search once. NextOpp watches company career pages directly and tells you when something new appears — deduplicated, so the same role never reaches you twice.",
  },
  {
    icon: IconRewrite,
    title: "Prepare",
    body: "See your ATS match score and the exact keywords you’re missing. Tailor your resume against the posting — reworded from your real history, never invented.",
  },
  {
    icon: IconBoard,
    title: "Apply",
    body: "Prep the full packet, autofill the form on the board, and track it in your pipeline. You click Submit yourself. Always.",
  },
];

export default function Workflow() {
  return (
    <ol className="grid md:grid-cols-3 gap-8 lg:gap-12" data-testid="landing-workflow">
      {STEPS.map((s, i) => (
        <li key={s.title}>
          <div className="flex items-center gap-3">
            {/* A night chip lit from inside, on warm paper. The dark sections
                and the light ones are the same world seen at different hours,
                so the lit sections carry small pieces of the night and the
                night carries the light — otherwise they are just stripes. */}
            <span className="w-9 h-9 rounded-sm bg-night text-dawn-300 grid place-items-center shrink-0">
              <s.icon className="w-[18px] h-[18px]" />
            </span>
            <span className="font-mono text-xs text-stone-600">0{i + 1}</span>
          </div>
          <h3 className="mt-5 font-heading text-2xl font-bold tracking-tight text-ink">
            {s.title}
          </h3>
          <p className="mt-2.5 text-[15px] text-stone-600 leading-relaxed">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}
